export default (values) => {

  const errors = {};

  if (!values.project_id) errors.project_id = true;
  if (!values.client_contact_id) errors.client_contact_id = true;
  if (!values.user_id) errors.user_id = true;
  if (!values.date) errors.date = true;

  if (values.certificate_amount !== null && values.certificate_amount !== undefined && values.certificate_amount !== '') {
    const numberPattern = /^[0-9]*\.?[0-9]*$/;
    const stringValue = String(values.certificate_amount);
    if (!numberPattern.test(stringValue)) {
      errors.certificate_amount = 'Please enter a valid number';
    }
  }

  return errors;
  
}